'use client';
import { useTranslations } from 'next-intl';
import { TextContent } from '@//components/TextContent';

export const RightOfExchange: React.FC = () => {
  const t = useTranslations('pages.item.moreInformationSection.rightOfExchange');

  return (
    <TextContent textSize="md">
      <p>{t('description')}</p>
    </TextContent>
  );
};
